import { cn } from "../../../../../utils/classnames";

/**
 * Hairlines take no space in Figma but 1px here, so the gap above each one
 * is 1px less than the design value.
 *
 * The two title styles the design uses for these cards:
 *   "feature"   — 16px medium title, roomier spacing (the airport info blocks)
 *   "highlight" — 15px bold title, tighter spacing (the golf note)
 */
const TITLE_STYLES = {
  feature: {
    titleClass: "tw:font-medium tw:text-[16px] tw:leading-[normal]",
    ruleSpacingClass: "tw:mt-[21px] tw:mb-[22px]",
  },
  highlight: {
    titleClass: "tw:font-bold tw:text-[15px] tw:leading-[22px]",
    ruleSpacingClass: "tw:mt-[17px] tw:mb-[18px]",
  },
};

/**
 * Light grey panel holding one short piece of supporting copy, with a title
 * and a hairline above the body.
 *
 * `contentClassName` styles the wrapper around the children — used by cards
 * that have to spread their content over the full card height.
 */
export const InfoCard = ({
  title,
  titleStyle = "feature",
  children,
  className,
  contentClassName,
}) => {
  const { titleClass, ruleSpacingClass } = TITLE_STYLES[titleStyle];

  return (
    <div
      className={cn(
        "tw:bg-[#F9F9F9] tw:rounded-[8px] tw:p-6 tw:lg:p-8",
        className
      )}
    >
      <div
        className={cn("tw:font-hanken-grotesk tw:text-[#282828]", titleClass)}
      >
        {title}
      </div>
      <div className={cn("tw:h-px tw:bg-[#F1F1F1]", ruleSpacingClass)} />
      <div
        className={cn(
          "tw:font-hanken-grotesk tw:text-[#4E4E4E] tw:text-[14px] tw:leading-[20px]",
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};
